











































import BankImg from '@/components/image/BankImg.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import BANK_CODES from '@/constants/bank-codes'
import DISABLE_TRANSFER_BANK_CODES from '@/constants/disable-transfer-bank-codes'
import DISABLE_PAYMENT_BANK_CODES from '@/constants/disable-payment-bank-codes'

type BankCodeType = 'transfer' | 'payment' | 'client'

@Component({
  components: {BankImg}
})
export default class BankCodeSelection extends Mixins(Translation) {
  @Prop({default: 'components.bank-codes', type: String}) translation: string
  @Prop({default: 'client', type: String}) type: BankCodeType

  selectedCode: string = ''

  get bankCodes(): string[] {
    const {type} = this
    switch(type) {
      case 'client':
        return BANK_CODES
      case 'payment':
        return BANK_CODES.filter((code) => !DISABLE_PAYMENT_BANK_CODES.includes(code))
      case 'transfer':
        return BANK_CODES.filter((code) => !DISABLE_TRANSFER_BANK_CODES.includes(code))
      default:
        return BANK_CODES
    }
  }

  get disabledBanksToText(): string {
    const {ts, type} = this
    switch(type) {
      case 'client':
        return ''
      case 'payment':
        return DISABLE_PAYMENT_BANK_CODES.map((code) => `${ts(`bank-codes.${code}`)}${ts('bank')}`).join(', ')
      case 'transfer':
        return DISABLE_TRANSFER_BANK_CODES.map((code) => `${ts(`bank-codes.${code}`)}${ts('bank')}`).join(', ')
      default:
        return ''
    }
  }

  isSelected(code) {
    return this.selectedCode === code
  }

  selectCode(code) {
    this.selectedCode = code
    this.$emit('code-selected', code)
  }
}
